import { useState, useEffect } from 'react';
import { CSVParser } from '@services/csv-parser';
import { BonusParser } from '@services/bonus-parser';
import type { Question } from '@/types';

interface UseCSVDataReturn {
  questions: Question[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useCSVData = (): UseCSVDataReturn => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async (): Promise<void> => {
    try {
      setLoading(true);
      setError(null);

      // Get parser instance
      const parser = CSVParser.getInstance();

      // Fetch questions and bonus levels in parallel
      const [questionsData] = await Promise.all([
        parser.fetchQuestions(),
        BonusParser.loadBonusLevels(),
      ]);

      setQuestions(questionsData);
      console.log(`✅ Loaded ${questionsData.length} questions`);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Erreur inconnue';
      setError(message);
      console.error('❌ CSV fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    questions,
    loading,
    error,
    refetch: fetchData,
  };
};
